import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_GET_DOCUMENT } from "../modals/Constants";
import HeaderView from "../other-components/HeaderView/view";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import general from "../css/General.module.css";
import FooterView from "../other-components/FooterView/view";

function Document() {
    let { urlParam } = useParams();
    const [loading, setLoading] = useState(false);

    const [values, setValues] = useState({
        document: "",
    });

    function loadRecords() {
        const fecthApiData = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(formData),
                });
                const data = await res.json();
                setLoading(false);

                if (data.status_code == "success") {
                    setValues({
                        ...values,
                        document: data.data,
                    });
                }
            } catch (error) {
                setLoading(false);
            }
        };

        setLoading(true);
        const formData = {
            DOCUMENT: urlParam
        };

        fecthApiData(API_GET_DOCUMENT, formData);
    }

    useEffect(() => {
        if (urlParam != "") {
            loadRecords();
        }
    }, []);

    return (
        <div className={[general.appView]}>
            <LoadingDialog isOpen={loading} />

            <div className={[general.appChildView]}>
                <HeaderView screen={"mybag"} />

                <div className={[general.appContentsView, general.mgT30px].join(" ")}>
                    <div className={[general.fontSize20px, general.pd15px].join(" ")}
                        dangerouslySetInnerHTML={{ __html: values.document }}
                    />
                </div>

                <FooterView />
            </div>
        </div>
    );
}

export default Document;